module.exports = "<div class=\"row \">\n    <div id=\"End\" class=\"col-sm-12 color-red \">\n        <p></p>\n        <p style=\"text-align:center\">Wiktor Sacewicz - 2018 © Wszelkie prawa zastrzeżone </p>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// P:/Portfolio-angular-master/src/app/mid/end/end.component.html
// module id = ../../../../../src/app/mid/end/end.component.html
// module chunks = main